import { useEffect, useState } from 'react';

const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

const diff = (endAt) => {
  const ms = new Date(endAt).getTime() - Date.now();
  if (ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  return { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60 };
};

export const EarlyAccessCountdown = ({ endAt, label = 'Early access ends in', dark = true }) => {
  const [left, setLeft] = useState(() => diff(endAt));
  useEffect(() => {
    const t = setInterval(() => setLeft(diff(endAt)), 1000);
    return () => clearInterval(t);
  }, [endAt]);
  if (!left) return null;
  const fg = dark ? '#FFFCF7' : '#726158';
  const sub = dark ? 'rgba(255,252,247,0.6)' : '#AA9283';
  const cell = { background: dark ? 'rgba(255,252,247,0.06)' : 'rgba(184,149,106,0.1)', border: `1px solid ${dark ? 'rgba(184,149,106,0.35)' : 'rgba(184,149,106,0.3)'}`, borderRadius: 12, minWidth: 64, padding: '10px 6px' };
  return (
    <div className="mt-6" data-testid="early-access-countdown" aria-live="polite">
      <p className="text-xs tracking-[0.18em] uppercase mb-3" style={{ color: '#B8956A' }}>{label}</p>
      <div className="flex justify-center gap-2 sm:gap-3">
        {[['days', 'Days'], ['hours', 'Hours'], ['minutes', 'Min'], ['seconds', 'Sec']].map(([k, label]) => (
          <div key={k} style={cell} data-testid={`countdown-${k}`}>
            <div className="font-serif text-2xl sm:text-3xl font-bold tabular-nums leading-none" style={{ color: fg }}>{pad(left[k])}</div>
            <div className="text-[10px] sm:text-xs uppercase tracking-wider mt-1" style={{ color: sub }}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
